import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Box,
} from "@mui/material";
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import { Menu as MenuIcon } from "@mui/icons-material";

// The API_URL and associated logic have been removed.

const Header = ({ toggleSidebar }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  // const [isRefreshing, setIsRefreshing] = useState(false); // State removed

  // --- User Menu Handlers ---
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // The handleRefreshData function has been removed.

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: "blur(15px)",
        borderBottom: "1px solid #e5e5e5",
        zIndex: 999,
        boxShadow: 'none',
      }}
    >
      <Toolbar>
        
        {/* 1. Sidebar Toggle Button */}
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleSidebar}
          sx={{ mr: 2, color: "#000" }} 
        >
          <MenuIcon />
        </IconButton>

        {/* 2. Dashboard Title/Logo */}
        <Typography variant="h6" sx={{ flexGrow: 1, color: "#000", display: "flex", alignItems: "center", gap: 1, fontSize: 16 }}>
          <SpaceDashboardIcon htmlColor="#000" />
          <span style={{ color: "#000" }}>
            Biometric Dashboard
          </span>
        </Typography>

        {/* 3. API Refresh Button with Loading Spinner (This Box component is now removed) */}
        {/* <Box sx={{ mr: 2 }}>...</Box> */}
        
        {/* 4. User Avatar and Menu */}
        <Box>
          <Avatar
            onClick={handleMenuOpen}
            sx={{ cursor: "pointer", bgcolor: "#0303c9", width: 32, height: 32, fontSize: 14 }}
          >
            A
          </Avatar>
          
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>Account Settings</MenuItem>
            <MenuItem onClick={handleMenuClose}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;